import React from 'react';
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TableSortLabel from "@material-ui/core/TableSortLabel";

function Index(props) {
  const {classes, onSelectAllClick, order, orderBy, onRequestSort, numSelected, rowCount} = props;
  const createSortHandler = (property) => (event) => {
    // onRequestSort(event, property);
  };

  const headCells = props.columns;
  // const rows= props.rows;


  return (
    <TableHead style={{background: '',}} className='table-header'>
      <TableRow>

        {/*<TableCell padding="checkbox">*/}
        {/*  <Checkbox*/}
        {/*    indeterminate={numSelected > 0 && numSelected < rowCount}*/}
        {/*    checked={rowCount > 0 && numSelected === rowCount}*/}
        {/*    onChange={onSelectAllClick}*/}
        {/*    inputProps={{'aria-label': 'select all desserts'}}*/}
        {/*  />*/}
        {/*</TableCell>*/}
        {headCells.map((headCell) => {
          let width1 = headCell.label.length > 8 ? "10%" : "7%";

          return (
            <TableCell
              key={headCell.id}
              // align={headCell.numeric ? 'right' : 'left'}
              // padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              // style={{width: width1}}
              className={headCell.id==='action'&&' text-center '}
              style={{padding:10}}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
              </TableSortLabel>

            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  );

}

export default Index;
